/**
 * Created by anthony on 7/7/14.
 */
var familyModel = angular.module('familyModel', ['fmThresholds', 'apWizardModel']);
familyModel.factory('FamilyModelFactory', function(BaseModel, AbstractModelService, ApplicationService, RestService, $q){

    var FamilyModelFactory = function(endpoint){
        BaseModel.apply(this, arguments);
        this.dataProperty = "data";
    }

    FamilyModelFactory.prototype = new BaseModel();
    FamilyModelFactory.prototype.parent = BaseModel.prototype;

    FamilyModelFactory.prototype.new = function(familyIndex)
    { 
        // this.resolveData(familyIndex);
        var newcopy = angular.copy(ApplicationService.getFamilyData().data[0]);
        newcopy['recordID'] = null;
        newcopy['Fam_Name_First'] = '';
        newcopy['Fam_Name_Middle'] = '';
        newcopy['Fam_Name_Last'] = '';
        newcopy['Fam_DOB'] = '';
        newcopy['Fam_Gender'] = '';
        newcopy['Fam_Addy1'] = '';
        newcopy['Fam_Addy2'] = '';
        newcopy['Fam_City'] = '';
        newcopy['Fam_State_Prov'] = '';
        newcopy['Fam_Zip'] = '';
        newcopy['Fam_Country'] = '';
        newcopy['Fam_Home_Phone'] = '';
        newcopy['Fam_Work_Phone'] = '';
        newcopy['Fam_Work_Phone_Ext'] = '';
        newcopy['Fam_Cell_Phone'] = '';
        newcopy['Fam_Occupation'] = '';
        newcopy['Fam_Employer'] = '';
        return ApplicationService.getFamilyData().data.push(newcopy) -1;
    }

    FamilyModelFactory.prototype.get = function()
    {
        if (!ApplicationService.isFamilyTwoSituation())
            return ApplicationService.getAwardData().family[0][this.dataProperty];
        else if (ApplicationService.getAwardData().family[0].data[0].familyID == this.familyID)
            return ApplicationService.getAwardData().family[0][this.dataProperty];
        else
            return ApplicationService.getAwardData().family[1][this.dataProperty];
    }

    FamilyModelFactory.prototype.set = function(item,  familyIndex)
    {
        if (typeof this.dataProperty === 'data')
            angular.copy(item, this.get(familyIndex));
        else
        {
            ApplicationService.getAwardData().family[familyIndex][this.dataProperty] = angular.copy(item);
        }
    }

    FamilyModelFactory.prototype.put = function(id, data, instance)
    {
        //data['familyID'] = id;
        return AbstractModelService.put("/api/family/" + id, data, instance)
    }

    FamilyModelFactory.prototype.post = function(id, data, instance)
    {
        data['familyID'] = id;
        return AbstractModelService.post("/api/family", data, instance)
    }

    FamilyModelFactory.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge("/api/family/" + id, data, instance)
    }

    FamilyModelFactory.prototype.revertCopy = function()
    {
        this.data = angular.copy(this.get());
    }

    FamilyModelFactory.prototype.updateCopy = function()
    {
        if (!ApplicationService.isFamilyTwoSituation())
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else if (ApplicationService.getAwardData().family[0].data[0].familyID == this.familyID)
            ApplicationService.getAwardData().family[0][this.dataProperty] = angular.copy(this.data);
        else
            ApplicationService.getAwardData().family[1][this.dataProperty]= angular.copy(this.data);

    }


    FamilyModelFactory.prototype.resolveData = function(familyIndex)
    {
        var arg = ApplicationService.getAwardData().family[familyIndex].data[0].familyID;
        var deferred = $q.defer();
        RestService.get(this.getEndpoint(arg)).then( (results) => {
            this.set(results.data, familyIndex);
            deferred.resolve(results);
        });
        return deferred.promise;
    }


    FamilyModelFactory.prototype.remove = function(index, familyIndex)
    {
        this.get(familyIndex).splice(index, 1);
    }

    FamilyModelFactory.prototype.getEndpoint = function(familyID)
    {
        if (typeof this.endpoint == "undefined")
            return "/api/family/" + familyID;
        else
            return "/api/family/" + familyID + this.endpoint;
    }


    return FamilyModelFactory;
});

familyModel.service('FamilyModelService', function(FamilyModelFactory){
    var familyModel = new FamilyModelFactory();
    return familyModel;
});
